import { WebCamInputBlockName } from "./blockNames.js";
/**
 * Custom input block deserializer to provide special behavior for input blocks in this library.
 *
 * @param smartFilter - The smart filter to create the block for
 * @param serializedBlock - The serialized block to create
 * @returns - The instantiated block, or null if the block type is not registered
 */
export async function InputBlockDeserializer(smartFilter, serializedBlock) {
    if (serializedBlock.name === WebCamInputBlockName) {
        const module = await import("./webCamInputBlock/webCamInputBlock.js");
        return new module.WebCamInputBlock(smartFilter);
    }
    return null;
}
//# sourceMappingURL=inputBlockDeserializer.js.map